
export default {
    list: [],
    amount:1,
    historic:[]
};